import style from './_style.scss';

import { executeOnDocumentReady } from '../../utils';
import searchFilters from './js/search-filters.js';
import searchControlSmartform from './js/search-control-smartform.js';

executeOnDocumentReady(() => {
	searchFilters();
	searchControlSmartform();
});
